export default "__VITE_ASSET__Cg2O5cl9__"